import * as React     from "react"
import {PacyAccount}  from "../../../../model/pacy/"
import BudgetPlanner1 from "../../budgetPlanner1/BudgetPlanner"
import PacyLoader     from "../../../../components/loaders/pacyLoader"
import Loading        from "../../../../components/loading/"
import PacyConfigs    from "./PacyConfigs"

interface PacyConfigsContainerOwnProps{
}
interface PacyConfigsContainerProps extends PacyConfigsContainerOwnProps{
  account     : PacyAccount
  loadingPacy : boolean
}

const PacyConfigsContainer = (props:PacyConfigsContainerProps) => {
  if(props.loadingPacy){return <Loading translateId="loadings.budgetPlanner"/>}
  if(!props.account){return <BudgetPlanner1/>} // Old Budget Planner, should be shown if Pacy account is not migrated/created yet
  return <PacyConfigs/>
}

export default PacyLoader()(PacyConfigsContainer) as React.ComponentType<PacyConfigsContainerOwnProps>
